<template>
  <card>
    <product-rule-form :product-rule="productRule"
                       @submit="onSubmit"/>
  </card>
</template>
<script>
  import ProductRuleForm from './ProductRuleForm'
  import ProductService from 'src/services/ProductService'
  export default {
    name: 'product-rule-create',
    components: {
      ProductRuleForm
    },
    data() {
      return {
        productRule: {}
      }
    },
    methods: {
      async onSubmit (data) {
        let productId = this.$route.params.id;
        await ProductService.updateProductRule(productId, data);
        this.$router.push(`/settings/products/${productId}`);
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let {id, ruleId} = to.params;
        let res = await ProductService.getProductRule(id, ruleId);
        let productRule = res.data
        if (productRule) {
          next(vm => {
            vm.productRule = productRule
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }
  }
</script>
